export { default as Accordion } from './accordion';

//# sourceMappingURL=index.js.map